import { ReactNode, createContext, useContext, useMemo, useRef } from 'react';
import {
  KioskKeyboard,
  KioskKeyboardRef,
  KioskKeyboardStyle,
} from './kiosk-keyboard';

export interface KioskKeyboardProviderProps {
  enabled: boolean;
  children?: ReactNode;
}

const KioskKeyboardContext = createContext<KioskKeyboardRef | undefined>(
  undefined
);

const KioskKeyboardProvider = (props: KioskKeyboardProviderProps) => {
  const { children, enabled } = props;

  const keyboardRef = useRef<KioskKeyboardRef>();

  const value = useMemo<KioskKeyboardRef>(() => {
    return {
      setStyle: (style: KioskKeyboardStyle) => {
        if (keyboardRef.current) {
          keyboardRef.current.setStyle(style);
        }
      },
    };
  }, []);

  return (
    <KioskKeyboardContext.Provider value={value}>
      {children}
      {enabled && <KioskKeyboard ref={keyboardRef} />}
    </KioskKeyboardContext.Provider>
  );
};

const useKioskKeyboard = (): KioskKeyboardRef => {
  return useContext(KioskKeyboardContext) as KioskKeyboardRef;
};

export { KioskKeyboardProvider, useKioskKeyboard };
